import { render, staticRenderFns } from "./gameTemp.vue?vue&type=template&id=b475dc86&scoped=true&"
import script from "./gameTemp.vue?vue&type=script&lang=js&"
export * from "./gameTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475dc86",
  null
  
)

export default component.exports